import React from 'react'
import styled from 'styled-components'
import Typography, {TypographyProps} from '@mui/material/Typography'
import typographyStyles from './typography.styles'

interface ApTypographyProps extends TypographyProps {
  ap_type?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'h7'
    | 'title'
    | 'subtitle'
    | 'label1'
    | 'label2'
    | 'body'
    | 'body2'
    | 'button'
  ap_color?: 'highlight' | 'success' | 'warn' | 'error' | string
  ahd_type?:
    | 'currentStep'
    | 'calDate'
    | 'calDateD'
    | 'calDateS'
    | 'fData'
    | 'formLabel'
    | 'inline'
    | 'navLink'
    | 'pButton'
    | 'h7'
    | 'h6'
    | 'popHeader'
    | 'regText'
    | 'sButton'
    | 'sData'
    | 'sData inline'
    | 'sLabel'
    | 'sLink'
    | 'mLink'
    | 'selectableDate'
    | 'selectableTime'
    | 'selectedDate'
    | 'selectedTime'
    | 'product'
    | 'subheading'
    | 'status'
    | 'step'
    | 'uid'
}

const apAtomName = {ap_atom_name: 'typographyAtom'}
const TypographyAtom = styled((props: ApTypographyProps) => (
  <Typography {...apAtomName} {...props} />
))`
  ${typographyStyles}
`

export default TypographyAtom
